import { useState } from 'react';
import { useSelector } from 'react-redux';
import { updateCliente } from '../../helpers/api_helper';

const useUpdateCliente = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const updateClienteHook = async (CLIPRO, datosCliente) => {
        setLoading(true);
        setError(null);
        try {
            console.log('Datos a actualizar:', datosCliente);
            const params = { tenantId, empresa, departamento };
            const response = await updateCliente(
                CLIPRO,
                { sg_maerutData: datosCliente, usuario: userInfo?.name },
                params
            );
            console.log('Response from API:', response);
            if (response) {
                console.log('Cliente actualizado con éxito');
                return { success: true };
            } else {
                throw new Error(response.message || 'Error al actualizar el cliente');
            }
        } catch (err) {
            const errorMessage = `Failed to update cliente: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { updateCliente: updateClienteHook, loading, error };
};

export default useUpdateCliente;
